import { SystemText } from '@salesperformanceint/e4shared';
import React from 'react';

export const TextClamp = ({ children, lines, callback, collapse }) => {
    const [init, setInit] = React.useState(false);
    const [clamped, setClamped] = React.useState(true);
    const [clampOpen, setClampOpen] = React.useState(false);
    const clamp = React.useRef(false);

    React.useEffect(() => {
        if (clamp.current && !init) {
            const set = clamp.current.scrollHeight > clamp.current.clientHeight;
            setClamped(set);
            setClampOpen(false);
            setInit(true);

            if (set) {
                clamp.current.classList.add('pointer');
            }
        }
    }, [clamp.current]);

    React.useEffect(() => {
        if (collapse) {
            clamp.current && clampOpen && expandText();
        }
    }, [collapse]);

    const expandText = () => {
        if (clamp.current.classList.contains('lines')) {
            clamp.current.classList.remove('lines');
            clamp.current.classList.remove(`lines-${lines}`);
            setClampOpen(true);
        } else {
            clamp.current.classList.add('lines');
            clamp.current.classList.add(`lines-${lines}`);
            setClampOpen(false);
        }

        callback?.();
    };

    return (
        <>
            <div
                ref={clamp}
                data-testid="clamped-text"
                className={`lines lines-${lines}`}
                onClick={() => {
                    clamped ? expandText() : null;
                }}
            >
                {children}
            </div>
            {clamped && (
                <div
                    className="mt10 pointer"
                    onClick={() => {
                        expandText();
                    }}
                >
                    [{clampOpen ? SystemText('General/Controls/Clamp/Open') : SystemText('General/Controls/Clamp/Closed')}]
                </div>
            )}
        </>
    );
};

export default TextClamp;
